import { Settings } from '$/io.ox/core/settings'

export const defaults = {}

export const settings = new Settings('trustedMail', () => defaults)
